import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import { FaArrowUp, FaArrowDown, FaChartBar } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import axios from "axios";
// import StockLedger from "./tabs/StockLedger";
// import StockAgeing from "./tabs/StockAgeing";
// import StockMovement from "./tabs/StockMovement";
import CashFundFlow from "./tabs/CashFundFlow";
import FundFlow from "./tabs/FundFlow";
import CashFlowSummary from "./tabs/CashFlowSummary";
import FundFlowNext from "./tabs/FundFlowNext";

const FinancialAnalysisReport = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const location = useLocation();
  //   const [defaultPDCAccountData, setDefaultPDCAccountData] = useState([]);

  const CustomTab = ({ label, icon, ...props }) => {
    return (
      <Tab
        label={
          <span className="flex items-center space-x-2">
            <span className="text-lg transition-transform duration-200 group-hover:scale-110 group-[.Mui-selected]:scale-110 group-[.Mui-selected]:text-white">
              {icon}
            </span>
            <span className="font-semibold group-[.Mui-selected]:text-white">
              {label}
            </span>
          </span>
        }
        className={` group relative text-sm font-medium 
               transition-all duration-300 ease-in-out
               hover:text-red-600 hover:bg-red-100 hover:shadow-sm hover:scale-90 hover:rounded-md
               [&.Mui-selected]:text-white 
               [&.Mui-selected]:bg-red-600
               [&.Mui-selected]:border-b-4 [&.Mui-selected]:border-red-200
               [&.Mui-selected]:shadow-md
               [&.Mui-selected]:rounded-md
               focus:outline-none focus:ring-0 focus:ring-none focus:ring-opacity-0 text-white
               px-4 py-3 rounded-t-lg
               min-w-[120px] md:min-w-[150px]`}
        sx={{
          "&:focus": {
            zIndex: 10,
          },
        }}
        aria-label={label}
        {...props}
      />
    );
  };

  useEffect(() => {
    const tabIndexFromChild = location.state?.tabIndex;

    if (typeof tabIndexFromChild === "number") {
      setTabIndex(tabIndexFromChild);
    } else {
      setTabIndex(0);
    }

    window.history.replaceState({}, document.title);
  }, [location.state]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const issueStoreAccounts = ["1", "2", "3"];

  return (
    <div className="mx-4">
      <h2 className="text-xl text-gray-800 my-4">Financial Analysis Report</h2>

      <div className=" border-b  p-2">
        <div className="rounded-md">
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            className=""
            TabIndicatorProps={{
              className: "hidden",
            }}
          >
            <CustomTab label="Cash Flow" icon={<FaArrowUp className="" />} />
            <CustomTab
              label="Fund Flow"
              icon={<FaArrowUp className="" />}
              />
            <CustomTab
              label="Cash Flow Summary"
              icon={<FaChartBar className="" />}
              /> 
            <CustomTab
              label="Fund Flow Next 7/30/90 Days"
              icon={<FaArrowUp className="" />}
            /> 
          </Tabs>
        </div>
      </div>

      <div className="">
        <div hidden={tabIndex !== 0}>
          <CashFundFlow issueStoreAccounts={issueStoreAccounts} />
        </div>
        <div hidden={tabIndex !== 1}>
          <FundFlow />
        </div>
        <div hidden={tabIndex !== 2}>
          <CashFlowSummary />
        </div>
        <div hidden={tabIndex !== 3}>
          <FundFlowNext />
        </div>
      </div>
    </div>
  );
};

export default FinancialAnalysisReport;
